import router from "@/router";
import { LOGOUT, REFRESH_TOKEN } from "../constants/actions";
import { GET_IS_LOGGED_IN, GET_TOKEN } from "../constants/getters";
import { SET_TOKEN, SET_USER } from "../constants/mutations";
import { AUTOMATION_SOCKET, CP_DETECT_SOCKET, ERROR_CAPTURE_SOCKET } from "@/sockets";
import debounce from 'lodash.debounce'
import { UNIVERSALAI_SOCKET } from "@/sockets/universal-ai";
import { MSAL } from "@/msal";
export default {
  state: {
    token: '',
  },
  getters: {
    [GET_IS_LOGGED_IN](state,getters){ return !!getters[GET_TOKEN]},
    [GET_TOKEN](state){ return state.token },
  },
  actions: {
    [REFRESH_TOKEN]: debounce(async function(context){
      try {
        const result = await MSAL.getAccessToken()
        if(!result) throw new Error('Failed to refresh token')
        context.commit(SET_TOKEN,result.accessToken)
        context.commit(SET_USER,{
          name: result.user.name,
          email: result.user.email,
        }, { root: true })
      } catch (ex) {
        context.commit(SET_TOKEN,'')
        context.commit(SET_USER,null,{ root: true })
        CP_DETECT_SOCKET.disconnect()
        ERROR_CAPTURE_SOCKET.disconnect()
        UNIVERSALAI_SOCKET.disconnect()
        AUTOMATION_SOCKET.disconnect()
        const requiresAuth = router.currentRoute.matched.some((record) => record.meta.requiresAuth)
        if(requiresAuth) router.push('/login')
      }
    },3*1000,{
      leading: true,
      trailing: false,
    }),
    async [LOGOUT](context){
      try {
        await MSAL.logout();
      } catch (ex) {
        // DO NOTHING - 
      } finally {
        context.commit(SET_TOKEN,'')
        context.commit(SET_USER,null,{ root: true })
        CP_DETECT_SOCKET.disconnect()
        ERROR_CAPTURE_SOCKET.disconnect()
        UNIVERSALAI_SOCKET.disconnect()
        AUTOMATION_SOCKET.disconnect()
        const requiresAuth = router.currentRoute.matched.some((record) => record.meta.requiresAuth)
        if(requiresAuth) router.push('/login')
      }
    },
  },
  mutations: {
    [SET_TOKEN](state,value){
      state.token=value ?? ''
    },
  },
};